export default __webpack_public_path__ + "static/media/hero_logo_horizontal_white.d1e36d86.png";